import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import ModalPortal from '../../../../components/modal-portal';
import messages from '../messages';
import AsModal from '../../../../components/as-modal';

import style from '../style.module.less';

const WarningShipFromModal = ({ onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style.modal}>
        <ModalHeader>
          <FormattedMessage {...messages.warningHeader} />
        </ModalHeader>
        <ModalBody className={style['delete-ship-from-modal-body']}>
          <div className={style.warning}>
            <FormattedMessage {...messages.warningMessage} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} theme='primary'>
            <FormattedMessage {...messages.ok} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

WarningShipFromModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onWarn: PropTypes.func.isRequired,
};

export default AsModal(WarningShipFromModal);
